import React, {Component}    from 'react';
import PropTypes from 'prop-types';
import urlHandler                       from '../../utils/urlHandler';
import settings                         from '../../utils/settings';
import permissions                      from '../../utils/permissions';
import ReactModal                       from 'react-modal';
import ReactTooltip                     from 'react-tooltip';
import {Tab, Tabs, TabList, TabPanel}   from 'react-tabs';
import MultipleCheckBoxes               from './MultipleCheckBoxes';

class SettingsDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.reset = this.reset.bind(this);
        this.onChangeSentimentModel = this.onChangeSentimentModel.bind(this);
        this.onSelectFieldChange = this.onSelectFieldChange.bind(this);
        this.onCheckboxFieldChange = this.onCheckboxFieldChange.bind(this);
        this.onInformationExtractionChange = this.onInformationExtractionChange.bind(this);
        this.onChangeTextCorrections = this.onChangeTextCorrections.bind(this);
        this.onChangeTypes = this.onChangeTypes.bind(this);
        this.onSelectAllTypes = this.onSelectAllTypes.bind(this);

        this.state = {
            error: '',
            modalOpen: false,

            sentimentModel: this.props.permissions.sentiment ? settings.getValue('sentimentModel', window._sentimentModel) : 'none',
            sentimentVals: [],

            salienceModel: settings.getValue('salienceModel', 'News'),
            salienceVals: [],

            languageCode: settings.getValue('languageCode', 'en'),
            languageVals: 'en'.split(','),

            informationExtractionSelected: this.props.permissions.informationExtractionPrompts ? settings.getValue('informationExtractionSelected', '-------') : '-------' ,
            


            informationExtraction: false,

            gdm: settings.getValue('gdm', 'base'),
            gdmVals: 'base'.split(','),
            showGdms: false,

            textCorrects: settings.getValue('textCorrects') || [],

            entityVals: [],

            extractRelationships: settings.getValue('extractRelationships', true),
            entitySummarization: settings.getValue('entitySummarization', true),
            documentSummarization: settings.getValue('documentSummarization', true),
            sentenceSalience: settings.getValue('sentenceSalience', true),
            coreferences: settings.getValue('coreferences', true),
            geocodeStreets: settings.getValue('geocodeStreets', true),
            forceEnglish: settings.getValue('forceEnglish', true)
        };
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_SettingsDialog');

        var perms = permissions.getAll();
        if (perms) {
            var languageVals = perms['language'] || [];
            var sentimentVals = perms['sentimentModels'] || [];
            var salienceVals = perms['salienceModels'] || [];
            var entityVals = perms['entities'] || [];
            var gdms = perms['GDM'] || [];            
            var show = false;
            gdms.map((g) => {
                if (g && g !== 'base') {
                    show = true;
                }
            });

            if(entityVals.includes('*')){
                entityVals = entityVals.filter((e) => e !== '*')
                entityVals.push('OTHER');
            }

            entityVals.sort((a, b) => {
                const nameA = a.toUpperCase(); // ignore upper and lowercase
                const nameB = b.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
                    
            var storedTypes = settings.getValue('types', []);

            entityVals = entityVals.map((name) => {
                let obj = storedTypes.find((type) => type.name === name);
                if (obj) {
                    return {
                        name,
                        'selected': obj.selected
                    }
                } else {
                    return {
                        name,
                        'selected': true
                    }
                }
            })
       
            settings.setValue('types', entityVals);

            // Add none option to sentiment models. This allows user to hide sentiment.
            sentimentVals.splice(0,0,'none')

            // Add none option to salience models. This allows user to hide salience.
            salienceVals.splice(0,0,'none')

            this.setState({
                sentimentModel: this.props.permissions.sentiment ? settings.getValue('sentimentModel', window._sentimentModel) : 'none',
                sentimentVals,
                salienceModel: settings.getValue('salienceModel', 'News'),
                salienceVals,
                languageCode: settings.getValue('languageCode', 'en'),
                languageVals,
                entityVals,
                gdm: settings.getValue('gdm', 'base'),
                gdmVals: [...new Set(this.state.gdmVals.concat(gdms))],
                showGdms: show,
                informationExtractionSelected: this.props.permissions.informationExtractionPrompts ? settings.getValue('informationExtractionSelected', '-------') : '-------',
                informationExtraction: settings.getValue('informationExtraction', false),
                textCorrects: settings.getValue('textCorrects', []),
                extractRelationships: settings.getValue('extractRelationships', true),
                entitySummarization: settings.getValue('entitySummarization', true),
                documentSummarization: settings.getValue('documentSummarization', true),
                sentenceSalience: settings.getValue('sentenceSalience', true),
                coreferences: settings.getValue('coreferences', true),
                geocodeStreets: settings.getValue('geocodeStreets', true),
                forceEnglish: settings.getValue('forceEnglish', true)
            });
        }
    }

    reset(open) {

        var storedTypes = settings.getValue('types', []);
        var vals = this.state.entityVals.map((type) => {
            let obj = storedTypes.find((st) => st.name === type.name);
            if (obj) {
                return {
                    name: type.name,
                    'selected': obj.selected
                }
            } else {
                return {
                    name: type.name,
                    'selected': true
                }
            }
        })

        this.setState({ 
            error: '',
            sentimentModel: this.props.permissions.sentiment ? settings.getValue('sentimentModel', window._sentimentModel) : 'none',
            salienceModel: settings.getValue('salienceModel', 'News'),
            languageCode: settings.getValue('languageCode', 'en'),
            informationExtractionSelected: this.props.permissions.informationExtractionPrompts ? settings.getValue('informationExtractionSelected', '-------') : '-------',
            gdm: settings.getValue('gdm', 'base'),
            textCorrects: settings.getValue('textCorrects', []),
            modalOpen: open,
            entityVals: vals,
            extractRelationships: settings.getValue('extractRelationships', true),
            entitySummarization: settings.getValue('entitySummarization', true),
            documentSummarization: settings.getValue('documentSummarization', true),
            sentenceSalience: settings.getValue('sentenceSalience', true),
            coreferences: settings.getValue('coreferences', true),
            geocodeStreets: settings.getValue('geocodeStreets', true),
            forceEnglish: settings.getValue('forceEnglish', true)
        });
    };

    close() {
        this.setState({
            modalOpen: false
        })
    };

    open() {
        this.reset(true);
    };

    onChangeSentimentModel(event) {
        this.setState({
            sentimentModel: this.refs.sentimentModel.value
        }, () => {
            settings.setValue('sentimentModel', this.refs.sentimentModel.value);
            if (this.props.onChange) {
                this.props.onChange('sentimentModel');
            }
        });
    }

    onSelectFieldChange(fieldName){
        this.setState({
            [fieldName]: this.refs[fieldName].value
        }, () => {
            settings.setValue(fieldName, this.refs[fieldName].value);
        });
    }

    onCheckboxFieldChange(event, fieldName){
        if (event.target) {
            this.setState({
                [fieldName]: event.target.checked
            }, () => {
                settings.setValue(fieldName, this.state[fieldName]);
            })
        } 
    }

    onInformationExtractionChange(event, fieldName){
        if (event.target) {
            this.setState({
                [fieldName]: event.target.checked
            }, () => {
                settings.setValue(fieldName, this.state[fieldName]);
                if (this.props.onChange) {
                    this.props.onChange('informationExtraction');
                }
            })
        } 
    }

    onChangeTextCorrections(values) {
        this.setState({
            textCorrects: values
        }, () => {
            settings.setValue('textCorrects', values);
        });
    }

    onChangeTypes(event) {
        var targetElement = event.target;
        const entityVals = this.state.entityVals.map((t)=>Object.assign({},t))
        var obj = entityVals.find((type) => type.name === targetElement.name);
        if (obj) {
            obj.selected = targetElement.checked;
            this.setState({
                entityVals
            }, () => {
                settings.setValue('types', entityVals);
                // if (this.props.onChange) {
                //     this.props.onChange('types');
                // }
            });
        }
    }

    onSelectAllTypes(checked) {
        const entityVals = this.state.entityVals.map((t)=>Object.assign({},t))

        entityVals.map((type) => {
            type.selected = checked;
        });
        this.setState({
            entityVals
        }, () => {
            settings.setValue('types', entityVals);
            // if (this.props.onChange) {
            //     this.props.onChange('types');
            // }
        });
    }

    render() {
        const ieTemplates = settings.getValue('informationExtractionTemplates', null)
        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '35%',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                transform   : 'translate(-50%, -35%)',
                maxWidth    : '700px',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        const secondColumnStart = Math.floor(this.state.entityVals.length / 2);

        return (
           <span id="rm_SettingsDialog">
                <span data-tip data-for="settings_tooltip" className='fa fa-cog' onClick={ this.open }></span>  
                <ReactTooltip id="settings_tooltip" type="dark" effect="solid" place="top">
                    User settings for demo tool.
                </ReactTooltip>
                <ReactModal
                    isOpen={this.state.modalOpen}
                    contentLabel="Settings Form"
                    onRequestClose={this.close} 
                    style={styles}
                    closeTimeoutMS={500}>
                    <div className="settings-dialog">
                        <div className="settings-header">
                            Settings
                        </div>
                        <div className="settings-description">
                            <span className='fa fa-exclamation settings-description-icon'></span>
                            Note that the options selected on this page only effect this demo tool and not the API in general.    
                        </div>
                        <div className="settings-content">
                            <div className="settings-form">
                                <Tabs>
                                    <TabList>
                                        <Tab>General</Tab>
                                        <Tab>Entity Types</Tab>
                                    </TabList>

                                    <TabPanel>
                                        <div className="settings-panel">
                                            {this.props.permissions.sentiment && 
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>Sentiment Model:</label><br/>
                                                            <label className='field-description'>The model that will be used for sentiment analysis. 
                                                                NOTE: Sentiment applies to languages: <b><i>en</i></b>.</label>
                                                        </span>
                                                        <select className='field-value form-field'
                                                                name='sentimentModelField'
                                                                id='sentimentModelField'
                                                                ref='sentimentModel'
                                                                value={this.state.sentimentModel}
                                                                onChange={this.onChangeSentimentModel}>
                                                            {this.state.sentimentVals.map((model) => {
                                                                return <option key={model.trim()} value={model.trim()}>{model.trim()}</option>
                                                            })}
                                                        </select>
                                                    </span>
                                                </div>
                                            }
                                            <div>
                                                <span className='field-wrapper'>
                                                    <span className="field-overview">
                                                        <label className='field-label'>GDM:</label><br/>
                                                        <label className='field-description'>The geo manager to be used for place extraction 
                                                            and disambiguation.</label>
                                                    </span>
                                                    <select className='field-value form-field'
                                                            name='gdmField'
                                                            id='gdmField'
                                                            ref='gdm'
                                                            value={this.state.gdm}
                                                            onChange={()=>this.onSelectFieldChange('gdm')}>
                                                        {this.state.gdmVals.map((g) => {
                                                            return <option key={g.trim()} value={g.trim()}>{g.trim()}</option>
                                                        })}
                                                    </select>
                                                </span>
                                                </div>
                                            {this.props.permissions.salience && 
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>Salience Model:</label><br/>
                                                            <label className='field-description'>The model that will be used for salience analysis. 
                                                            NOTE: Salience applies to languages: <b><i>de, en, es, fr, nl</i></b>.</label>
                                                        </span>
                                                        <select className='field-value form-field'
                                                                name='salienceModelField'
                                                                id='salienceModelField'
                                                                ref='salienceModel'
                                                                value={this.state.salienceModel}
                                                                onChange={()=>this.onSelectFieldChange('salienceModel')}>
                                                            {this.state.salienceVals.map((model) => {
                                                                return <option key={model.trim()} value={model.trim()}>{model.trim()}</option>
                                                            })}
                                                        </select>
                                                    </span>
                                                </div>
                                            }
                                            {this.props.permissions.correctText &&
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>Text Corrections:</label><br/>
                                                            <label className='field-description'>Attempt to correct common text issues including 
                                                            capitalization, punctuation<br/>and tokenization. NOTE: Text correction applies to 
                                                            languages: <b><i>en</i></b>.</label>
                                                        </span>
                                                        <span className="field-value">
                                                            <MultipleCheckBoxes names={['case', 'punctuation', 'token']} 
                                                                defaultChecked={this.state.textCorrects}
                                                                onChange={this.onChangeTextCorrections}
                                                                className="tc_left"
                                                            />
                                                        </span>
                                                    </span>
                                                </div>
                                            }
                                            {permissions.getAll().features.includes('InformationExtraction') && permissions.getAll().entities.includes('*') && //this.props.permissions.informationExtractionPrompts && Array.isArray(ieTemplates) &&
                                                <div>
                                                    <div>
                                                        <span className='field-wrapper'>
                                                            <span className="field-overview">
                                                                <label className='field-label'>Information Extraction:</label><br/>
                                                                <label className='field-description'>Extract parameters and other information
                                                                    found in text during the enrichment process.{"\n"}<div style={{color:'red'}}>WARNING: Setting this value can cause enrichment calls to take significantly longer.</div> </label>
                                                            </span>
                                                            <span className="field-value">
                                                                <input type="checkbox" className="tc_left"
                                                                    value="information_extract" 
                                                                    onChange={(e)=>this.onInformationExtractionChange(e,'informationExtraction')}
                                                                    defaultChecked={this.state.informationExtraction}
                                                                    disabled={this.props.disabled}>
                                                                </input>
                                                            </span>
                                                        </span>
                                                    </div>  
                                                    <div>
                                                        <span className='field-wrapper'>
                                                            <span className="field-overview">
                                                                <label className='field-label'>Information Extraction Template:</label><br/>
                                                                <label className='field-description'>The template to be used for extracting parameters and other information.</label>
                                                            </span>
                                                            <select className='field-value form-field'
                                                                    name='ieField'
                                                                    id='ieField'
                                                                    ref='informationExtractionSelected'
                                                                    value={this.state.informationExtractionSelected}
                                                                    disabled={!this.state.informationExtraction || !this.props.permissions.informationExtractionPrompts}
                                                                    onChange={()=>this.onSelectFieldChange('informationExtractionSelected')}>
                                                                {
                                                                        [{description:'Default Prompt', name:'-------'}, ...(ieTemplates ? ieTemplates: [])].map((template) => {
                                                                        return <option key={template.name.trim()} value={template.name.trim()}>
                                                                            {template.name.trim()}
                                                                        </option>
                                                                })}
                                                            </select>
                                                        </span>
                                                    </div>      
                                                </div> 
                                            }
                                            {this.props.permissions.relationships &&
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>Relationship Extraction:</label><br/>
                                                            <label className='field-description'>Extract relationships found in text during 
                                                                the enrichment process. NOTE: Relationship extraction applies to 
                                                                languages: <b><i>en</i></b>.</label>
                                                        </span>
                                                        <span className="field-value">
                                                            <input type="checkbox" className="tc_left"
                                                                value="extract_relationships" 
                                                                onChange={(e)=>this.onCheckboxFieldChange(e,'extractRelationships')}
                                                                defaultChecked={this.state.extractRelationships}
                                                                disabled={this.props.disabled}>
                                                            </input>
                                                        </span>
                                                    </span>
                                                </div>                    
                                            }
                                            {this.props.permissions.entitySummarization &&
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>Entity Summarization:</label><br/>
                                                            <label className='field-description'>Return list of summary sentences per entity 
                                                                based on enrichment text. NOTE: Entity summarization applies to 
                                                                languages: <b><i>de, en, es, fr, nl</i></b>.</label>
                                                        </span>
                                                        <span className="field-value">
                                                            <input type="checkbox" 
                                                                className="tc_left"
                                                                value="entity_summarization" 
                                                                onChange={(e)=>this.onCheckboxFieldChange(e,'entitySummarization')}
                                                                defaultChecked={this.state.entitySummarization}
                                                                disabled={this.props.disabled}>
                                                            </input>
                                                        </span>
                                                    </span>
                                                </div>                    
                                            }
                                            {this.props.permissions.documentSummarization &&
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>Document Summarization:</label><br/>
                                                            <label className='field-description'>Return summary and/or list of summary sentences 
                                                                for the document. NOTE: Document summarization applies to 
                                                                languages: <b><i>de, en, es, fr, nl</i></b>.</label>
                                                        </span>
                                                        <span className="field-value">
                                                            <input type="checkbox" 
                                                                className="tc_left"
                                                                value="document_summarization" 
                                                                onChange={(e)=>this.onCheckboxFieldChange(e,'documentSummarization')}
                                                                defaultChecked={this.state.documentSummarization}
                                                                disabled={this.props.disabled}>
                                                            </input>
                                                        </span>
                                                    </span>
                                                </div>                    
                                            }
                                            {this.props.permissions.sentenceSalience &&
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>Sentence Salience:</label><br/>
                                                            <label className='field-description'>Return salience information for each sentence of 
                                                                the enrichment text. NOTE: Salience applies to 
                                                                languages: <b><i>de, en, es, fr, nl</i></b>.</label>
                                                        </span>
                                                        <span className="field-value">
                                                            <input type="checkbox" 
                                                                className="tc_left"
                                                                value="sentence_salience" 
                                                                onChange={(e)=>this.onCheckboxFieldChange(e,'sentenceSalience')}
                                                                defaultChecked={this.state.sentenceSalience}
                                                                disabled={this.props.disabled}>
                                                            </input>
                                                        </span>
                                                    </span>
                                                </div>                    
                                            }
                                            {this.props.permissions.coreferences &&
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>CoReferences:</label><br/>
                                                            <label className='field-description'>Return entities such as he, she, etc. that 
                                                                reference other disambiguated entities. NOTE: Coreference applies to 
                                                                languages: <b><i>en</i></b>.</label>
                                                        </span>
                                                        <span className="field-value">
                                                            <input type="checkbox" 
                                                                className="tc_left"
                                                                value="coreferences" 
                                                                onChange={(e)=>this.onCheckboxFieldChange(e,'coreferences')}
                                                                defaultChecked={this.state.coreferences}
                                                                disabled={this.props.disabled}>
                                                            </input>
                                                        </span>
                                                    </span>
                                                </div>                    
                                            }
                                            {this.props.permissions.geocodeStreets &&
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>Geocode Streets:</label><br/>
                                                            <label className='field-description'>Attempt to geocode extracted street addresses by 
                                                                enriching the corresponding entities with latitude, longitude and other GEO 
                                                                features. NOTE: Geocode streets applies to 
                                                                languages: <b><i>ar, de, en, es, fr, nl, ru</i></b>.</label>
                                                        </span>
                                                        <span className="field-value">
                                                            <input type="checkbox" 
                                                                className="tc_left"
                                                                value="geocodeStreets" 
                                                                onChange={(e)=>this.onCheckboxFieldChange(e,'geocodeStreets')}
                                                                defaultChecked={this.state.geocodeStreets}
                                                                disabled={this.props.disabled}>
                                                            </input>
                                                        </span>
                                                    </span>
                                                </div>                    
                                            }
                                            { this.state.languageVals && !(this.state.languageVals.length === 1 && this.state.languageVals[0]==='en') &&
                                                <div>
                                                    <span className='field-wrapper'>
                                                        <span className="field-overview">
                                                            <label className='field-label'>Force English:</label><br/>
                                                            <label className='field-description'>Sets the targetLanguage to English (different from languageCode/input text language). This setting causes
                                                                all extraction and enrichment to be performed in English language. NOTE: This setting ONLY applies 
                                                                to the <b>Entities</b> tab.</label>
                                                        </span>
                                                        <span className="field-value">
                                                            <input type="checkbox" 
                                                                className="tc_left"
                                                                value="forceEnglish" 
                                                                onChange={(e)=>this.onCheckboxFieldChange(e, 'forceEnglish')}
                                                                defaultChecked={this.state.forceEnglish}
                                                                disabled={this.props.disabled}>
                                                            </input>
                                                        </span>
                                                    </span>
                                                </div>   
                                            }                 
                                        </div>
                                    </TabPanel>
                                    <TabPanel>
                                        <div style={{display: 'flex', flex: '1', flexDirection: 'row-reverse', marginBottom: '10px'}}>
                                            <button className="link-button" style={{marginLeft: '20px', textDecoration: 'none'}} onClick={() => this.onSelectAllTypes(true)}> 
                                                <span className="fa fa-check-square-o">&nbsp;</span> 
                                                Select All 
                                            </button> 
                                            <button className="link-button" style={{marginLeft: '20px', textDecoration: 'none'}} onClick={() => this.onSelectAllTypes(false)}> 
                                                <span className="fa fa-square-o">&nbsp;</span> 
                                                Unselect All 
                                            </button>                                             
                                        </div>
                                        <div className="settings-panel">
                                            <div className="type-content-wrapper">
                                                <span>
                                                    <label className='type-description'>Select which types to use in the enrich process.</label>
                                                </span>
                                                <br/><br/>
                                                <div className="types-wrapper">
                                                    <div className="types-left">
                                                        {this.state.entityVals.slice(0,secondColumnStart).map((type) => {
                                                            return (
                                                            <div key={`key-${type.name}`}>
                                                                <input type="checkbox" name={`${type.name}`} 
                                                                    checked={ type.selected || (type.name === 'OTHER' && this.state.informationExtraction)}
                                                                    disabled={type.name === 'OTHER' && this.state.informationExtraction}
                                                                    onChange={ this.onChangeTypes }
                                                                />
                                                                <span className="text">{ type.name }</span>
                                                            </div>);
                                                        })}
                                                    </div>
                                                    <div className="types-right">
                                                        {this.state.entityVals.slice(secondColumnStart).map((type) => {
                                                                return (
                                                                <div key={`key-${type.name}`}>
                                                                    <input type="checkbox" name={`${type.name}`} 
                                                                        checked={ type.selected || (type.name === 'OTHER' && this.state.informationExtraction) }
                                                                        disabled={type.name === 'OTHER' && this.state.informationExtraction}
                                                                        onChange={ this.onChangeTypes }
                                                                    />
                                                                    <span className="text">{ type.name }</span>
                                                                </div>);
                                                            })}             
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </Tabs>
                                <br/>
                                <span className="settings-error-msg">{this.state.error}</span>
                            </div>
                        </div>
                        <div className="settings-footer">
                            <button type="button" className="settings-default-button" onClick={this.close}>Close</button>
                        </div>
                    </div>
                </ReactModal>
            </span>
        );
    };
}

SettingsDialog.propTypes = {
    onChange: PropTypes.func,
    permissions: PropTypes.object.isRequired
};

export default SettingsDialog;


